import React, {FC} from "react";
import './CaseEnd.css'
import Button from "../button/Button";
import CareLoadMeter from "../careLoadMeter/CareLoadMeter";
import {PatientData} from "../../CaseDataInterfaces";
import takeawayIcon from "./takeaway.svg";

interface Props {
    patient: PatientData;
    urgencyComparison: number; // correct - actual (but remember, numerical lower value is _higher_ urgency
    exitFn: () => void;
    nextFn: () => void;
    retryFn: () => void;
    levelComplete: boolean;
    takeawayMessage: string;
}
const CaseEnd: FC<Props> = ({patient, urgencyComparison, exitFn, nextFn, retryFn, levelComplete, takeawayMessage}) => {
    const defaultActions = <div className='case-end-actions'>
        <Button type='secondary' size='large' onClick={() => {exitFn()}} >Stoppen</Button>
        <Button type='primary' size='large' onClick={() => {nextFn()}} >{levelComplete ? 'Bekijk levelscore' : 'Volgende Patiënt'}</Button>
    </div>;

    const takeawayContent = <div className='case-end__takeaway'>
        <img src={takeawayIcon} alt='takeaway'/>
        {takeawayMessage}
    </div>;

    // 3 options: U too low, correct, too high. NOTE: a higher number for U is for something _less_ urgent
    if (urgencyComparison > 0) {
        return <div className='case-end case-end__care-load'>
            <div className='case-end-message'>Jouw zorgbelasting kan beter</div>
            <div className='case-end-summary'>
                <div className='case-end-summary-item'>
                    <h2>Geholpen patiënten <span className='case-end__plus_one'>+1</span></h2>
                    <div className='case-end-patient'>
                        <img src={patient.photo} alt='pasfoto patiënt'/>
                    </div>
                </div>
                <div className='case-end-summary-item'>
                    <h2>Zorgbelasting</h2>
                    <div className='case-end-care-load'>
                        <CareLoadMeter score='worse' size='medium' />
                    </div>
                </div>
            </div>
            {takeawayContent}
            <Button type='secondary' size='large' onClick={() => {
                retryFn();
            }}>Speel opnieuw</Button>
            {defaultActions}
        </div>;
    } else if (urgencyComparison < 0) {
        return <div className='case-end case-end__urgency'>
            <h1>Helaas</h1>
            <div className='case-end__urgency-messages'>Je hebt de patiënt niet juist geholpen. <br/>Deze patiënt zal zich snel weer melden.</div>
            <div className='case-end-summary-item'>
                <h2>Geholpen patiënten</h2>
                <span className='case-end__plus_zero'>+0</span>
            </div>
            {takeawayContent}
            {defaultActions}
        </div>;
    } else {
        return <div className='case-end case-end__good'>
            <h1>Goed werk!</h1>
            <div className='case-end-summary'>
                <div className='case-end-summary-item'>
                    <h2>Geholpen patiënten <span className='case-end__plus_one'>+1</span></h2>
                    <div className='case-end-patient'>
                        <img src={patient.photo} alt='pasfoto patiënt'/>
                    </div>
                </div>
                <div className='case-end-summary-item'>
                    <h2>Zorgbelasting</h2>
                    <div className='case-end-care-load'>
                        <CareLoadMeter score='good' size='medium' />
                    </div>
                </div>
            </div>
            {takeawayContent}
            {defaultActions}
        </div>;
    }
}

export default CaseEnd;